module.exports = __webpack_public_path__ + "img/profile-icon-filled.3260fd3.svg";